/**
 * @description Lista canónica de entidades emisoras de matrículas médicas
 *              en Argentina: 24 provincias + CABA + "Nacional" + "Sin
 *              especificar". Se usa en el dropdown "Entidad emisora" del
 *              alta/edición de prestadores (UserDetail.vue) para evitar
 *              que cada médico tipee una variante distinta del mismo lugar
 *              ("BsAs", "BS AS", "Buenos Aires", "Bs. As.", etc.) y que
 *              después la validación de receta de medicamentos falle.
 *
 *              Bug origen: BUG-WL688V (QA Tracker, 2026-06-24). Federico
 *              reportó que la entidad emisora era texto libre y el validador
 *              de recetas rechazaba por inconsistencia. Fix: convertir a
 *              dropdown con esta lista.
 *
 *              Backward compat: pacientes/doctores con `license.entity` que
 *              no matchea exactamente un valor de acá verán el campo vacío
 *              al abrir el modal de edición y deberán re-seleccionar.
 *              Decisión deliberada — no se hace migration porque limpia los
 *              valores históricos inconsistentes.
 */

/**
 * @description Las 24 provincias + CABA, ordenadas alfabéticamente
 *              (acentos al ordenar consistentes con la "real-world" lectura).
 */
export const PROVINCES = [
  "Buenos Aires",
  "CABA (Ciudad Autónoma)",
  "Catamarca",
  "Chaco",
  "Chubut",
  "Córdoba",
  "Corrientes",
  "Entre Ríos",
  "Formosa",
  "Jujuy",
  "La Pampa",
  "La Rioja",
  "Mendoza",
  "Misiones",
  "Neuquén",
  "Río Negro",
  "Salta",
  "San Juan",
  "San Luis",
  "Santa Cruz",
  "Santa Fe",
  "Sgo. del Estero",
  "Tierra del Fuego",
  "Tucumán",
];

/**
 * @description Opciones especiales para matrículas que no son provinciales
 *              estrictas. Se muestran en un grupo aparte del dropdown para
 *              que el médico no las confunda con una provincia.
 */
export const OTHER_ENTITIES = ["Nacional", "Sin especificar"];

/**
 * @description Lista flat (provincias + otros) para validación o checks
 *              donde no importa el agrupamiento.
 */
export const ALL_LICENSING_ENTITIES = [...PROVINCES, ...OTHER_ENTITIES];
